import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'

import {
  Grid,
  Icon,
  Button,
  Paper,
  Typography,
  withStyles,
} from '@material-ui/core'
import FlightCard from '../components/itinerary/flight/FlightCard'
import TripHeader from '../components/trip/TripHeader'
import AppTopBar from '../components/AppTopBar'
import DatesFilter from '../components/filters/DatesFilter'
import StayFilter from '../components/filters/StayFilter'
import TravelersFilter from '../components/filters/TravelersFilter'
import { config } from '../config.js'
import Helmet from 'react-helmet'
import startCase from 'lodash/startCase'

import './App.css'

const API = config.api.TRAVEL_URL + '/flights'

class Flights extends Component {
  constructor(props) {
    super(props)
    this.state = {
      flights: [],
      isLoading: false,
      error: false,
      flight: null,
      address: props.address || props.locationTo,
      search_params: this.props.search_params,
    }
  }

  componentDidMount() {
    if (!this.state.isLoading) {
      this.fetchFlights(this.props.search_params);
    }
  }

  fetchFlights(search_params) {
    let adults = '';
    let children = '';
    let infants = '';
    let dates_type = '';
    let start_date = '';
    let end_date = '';
    let nights = '';

    if (search_params) {
      adults = search_params.adults
      children = search_params.children
      infants = search_params.infants
      dates_type = search_params.dates_type
      start_date = search_params.start_date || ''
      end_date = search_params.end_date || ''
      nights = search_params.nights
    }

    this.setState({ isLoading: true })

    window.gtag('event', 'search', {group: 'Flight/Bus/Train'});

    fetch(API + '?location_from=' + this.props.locationFrom +
                '&location_to=' + this.props.locationTo +
                '&id=' + (this.props.trip_id ? this.props.trip_id : '') +
                '&adults=' + adults +
                '&children=' + children +
                '&infants=' + infants +
                '&dates_type=' + dates_type +
                '&start_date=' + start_date +
                '&end_date=' + end_date +
                '&nights=' + nights, {
      headers: {
        'X-USER': (this.props.user_id ? this.props.user_id : ''),
        'X-TRIP': (this.props.trip_id ? this.props.trip_id : '')
      }
    })
    .then(response => response.json())
    .then(response => {
      this.setState(previousState => ({
        flights: response.data,
        isLoading: false
      }));

      if (this.props.trip_id !== response.trip.id) {
        this.props.history.push(`/flights/to/${this.props.locationTo}/from/${this.props.locationFrom}/${response.trip.id}`)
      }
    })
    .catch((err) => this.setState({ isLoading: false, error: true }))
  }

  saveFilterSettings(params) {
    let search_params = {...this.state.search_params, ...params}

    if (JSON.stringify(this.state.search_params) !== JSON.stringify(search_params)) {
      this.setState({ search_params }, this.fetchFlights(search_params))
      this.props.onFilterChange(params)
    }
  }

  render() {
    const { classes } = this.props;
    const firstPrice = this.state.flights[0] ? this.state.flights[0].price : null

    return (
      <Fragment>
        <Helmet>
          <title>{`Find Cheap Flight, Train or Bus to ${startCase(this.props.locationTo)} ${firstPrice ? 'for $' + firstPrice : ''} ${this.props.locationFrom !== 'nearby' ? 'from ' + this.props.locationFrom : ''}`}</title>
        </Helmet>
        <AppTopBar
           onLocationChanged={this.props.onLocationChanged}
           onLocationCleared={this.props.onLocationCleared}
           onChange={this.props.onFilterChange}
           address={this.props.address}
           hideSearchBar={true}
        />
        <div className="layout">
          <div className="search-container">
            <TripHeader
              to={this.props.destination ? this.props.destination.to : this.state.address}
              startDate={this.props.search_params && this.props.search_params.start_date}
              endDate={this.props.search_params && this.props.search_params.end_date}
              nights={this.props.search_params && this.props.search_params.nights}
              adults={this.props.search_params && this.props.search_params.adults}
              children={this.props.search_params && this.props.search_params.children}
              infants={this.props.search_params && this.props.search_params.infants}
              flightPrice={this.state.flight && this.state.flight.price}
              hotelPrice={this.state.hotel && this.state.hotel.priceQuote.amount}
              searchParams={this.props.search_params}
              address={this.state.address}
              isLoading={this.state.isLoading}
              destination={this.props.destination}
              showStepper={true}
              activeStep={1}
            />
          </div>
        </div>

        <div className="trip-container">
          <Grid item xs={12} className={classes.gridFilters}>
            <div className="flights-container">
              <Grid container alignItems={'center'} justify={'center'}>

                <Grid item xs={12} className={classes.header}>
                  <Typography className={classes.section}>
                    {/* <Icon className={classes.icon}>flight</Icon> */}
                    <Fragment>
                      Choose transportation<br/>
                      {/* <small>Price includes taxes + fees. Additional baggage can be added during booking.</small> */}
                    </Fragment>
                  </Typography>
                </Grid>

                <Grid container alignItems={'flex-start'} justify={'flex-start'}>
                  <Paper className={classes.paperHeader}>
                    <Button size="medium" variant="outlined" className={classes.tripOrigin}>
                      <Icon className={classes.iconTripOrigin}>place</Icon>
                      From:
                      <span style={{marginLeft: 5}}>
                        {this.state.from_address ? this.state.from_address : 'Current Location'}
                      </span>
                    </Button>
                    <DatesFilter
                      dates_type = {this.props.search_params && this.props.search_params.dates_type}
                      start_date = {this.props.search_params && this.props.search_params.start_date}
                      end_date = {this.props.search_params && this.props.search_params.end_date}
                      onChange={this.saveFilterSettings.bind(this)}>
                    </DatesFilter>
                    <StayFilter
                      nights={this.props.search_params && this.props.search_params.nights}
                      onChange={this.saveFilterSettings.bind(this)}>
                    </StayFilter>
                    <TravelersFilter
                      adults={this.props.search_params && this.props.search_params.adults}
                      children={this.props.search_params && this.props.search_params.children}
                      infants={this.props.search_params && this.props.search_params.infants}
                      onChange={this.saveFilterSettings.bind(this)}>
                    </TravelersFilter>

                    {/* <div className={classes.actions}>
                      <Button size="medium" variant="outlined" className={classes.buttonSort}>
                        <Icon className={classes.iconSort}>sort</Icon>
                        Recommended
                      </Button>
                    </div> */}
                  </Paper>
                </Grid>

                <Grid item xs={12}>
                  {this.state.flights.map((flight, index) => {
                    return <FlightCard key={index}
                              flight={flight}
                              selected_flight_id={this.props.flight_id}
                              onSelected={this.props.onSelected.bind(this, flight, this.props.trip_id, this.props.locationFrom, this.props.locationTo)}
                              classes={{ root: classes.root }}/>
                  })}
                  {this.state.isLoading === false && this.state.flights.length < 1 &&
                    <Grid container className={classes.notFound}>
                      <Typography>We couldn't find any available flight to airports near your destination</Typography>
                    </Grid>
                  }
                </Grid>
              </Grid>
            </div>
          </Grid>
        </div>
      </Fragment>
    );
  }
}

const styles = theme => ({
  gridFilters: {
    textAlign: 'left',
    maxWidth: 1130,
    margin: '0px auto',
  },
  section: {
    fontSize: 19,
    fontWeight: 600,
    padding: '25px 15px 15px 0px',
    lineHeight: 1.2,

    '& small': {
      color: '#999',
      fontSize: '70%',
      fontWeight: 500,
    }
  },
  header: {
    padding: '0px !important',
  },
  root: {
    width: '100%',
    boxShadow: 'none',
    border: '1px solid #ddd',
    margin: '10px 0px',
    borderRadius: 10,

    '&::before': {
      backgroundColor: 'transparent',
    },
    '&:hover': {
      border: ' 1px solid #eee',
      boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    },
  },
  icon: {
    verticalAlign: 'middle !important',
    display: 'block',
    float: 'left',
    padding: '4px 11px 5px 5px !important',
  },
  notFound: {
    textAlign: 'center',
    padding: 50,
    borderRadius: 3,
    display: 'block',
    backgroundColor: '#fff',
    border: '1px solid #eee',
  },
  paperHeader: {
    width: '100%',
    // border: ' 1px solid #eee',
    padding: '10px 0px',
    boxShadow: 'none',
    backgroundColor: 'transparent',
  },
  iconSort: {
    padding: '0 !important',
    fontSize: 18,
    marginTop: -3,
    marginRight: 5,
  },
  actions: {
    float: 'right',
  },
  buttonSort: {
    color: '#444',
    textTransform: 'capitalize',
    border: '1px solid #eee',
    fontWeight: 500,
    fontSize: 12,
    height: 40,
    // backgroundColor: '#eee',
  },
  tripOrigin: {
    color: '#444',
    textTransform: 'capitalize',
    border: '1px solid #eee',
    fontWeight: 400,
    backgroundColor: '#eee',
    fontSize: 12,
    height: 40,
    verticalAlign: 'top',
    marginRight: 10,
    marginTop: 5,
    padding: '1px 8px 0px 8px',
  },
  iconTripOrigin: {
    padding: '0px !important',
    fontSize: 18,
    marginTop: -3,
    marginRight: 5,
  },
})

export default withStyles(styles)(withRouter(Flights));
